import { Tabs } from "@mantine/core";
import { useNavigate } from "react-router";
import { usePermission } from "@how/app-kit";

export type CheckInTab = "door" | "rooms";

const PATHS: Record<CheckInTab, string> = { door: "/check-in", rooms: "/check-in/rooms" };

/**
 * The Check-in section's tabs: the door (the station) and Rooms. Rooms is offered to those who manage events, the
 * permission the database asks of whoever changes a room; the door to those who check in, which the route enforces.
 */
export function CheckInTabs({ active }: { readonly active: CheckInTab }) {
  const navigate = useNavigate();
  const manage = usePermission("events.manage", { write: true });
  const checkIn = usePermission("events.check_in");
  const showRooms = manage.data === true || active === "rooms";
  const showDoor = checkIn.data === true || active === "door";
  if (!showRooms || !showDoor) return null;
  return (
    <Tabs
      value={active}
      onChange={(value) => {
        if (value !== null && value in PATHS) void navigate(PATHS[value as CheckInTab]);
      }}
      mb="lg"
    >
      <Tabs.List>
        <Tabs.Tab value="door">Door</Tabs.Tab>
        <Tabs.Tab value="rooms">Rooms</Tabs.Tab>
      </Tabs.List>
    </Tabs>
  );
}
